import { render, staticRenderFns } from "./Loan.vue?vue&type=template&id=835759ae&scoped=true"
import script from "./Loan.vue?vue&type=script&lang=js"
export * from "./Loan.vue?vue&type=script&lang=js"
import style0 from "./Loan.vue?vue&type=style&index=0&id=835759ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835759ae",
  null
  
)

export default component.exports